export function JSONAPIMatchStringProvider(columns, item){
  return columns.map(({attribute, itemRenderer}) => `${itemRenderer(item, {attribute})}`).join(' ')
}